var map = {
	"./DeliveryIcon.vue": [
		56260
	],
	"./HlsVideoPlayer.vue": [
		83994
	],
	"./InstoreIcon.vue": [
		1579
	],
	"./LanguageSwitcher.vue": [
		24962,
		581
	],
	"./PickupIcon.vue": [
		24107
	],
	"./StarIcon.vue": [
		24476
	],
	"./ToggleSidebar.vue": [
		86853
	],
	"./VenueNameTag.vue": [
		55375
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85957;
module.exports = webpackAsyncContext;